// Added by Jonghyung Lee on 2021-10-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

import { CleanupRule } from '@/helper/define'

interface ResGetCleanupRule {
  rule_data: CleanupRule
}

const baseUrl = 'v1/mgmt/datastorages/deletion-rules'

export const reqGetCleanupRule = async (token: string) => {
  return await axios.get<ResGetCleanupRule>(`${baseUrl}/${token}`)
}

export const reqCreateCleanupRule = async (token: string, rule: CleanupRule) => {
  return await axios.post(`${baseUrl}`, {
    data_token: token,
    rule_data: JSON.stringify({ ...rule }),
  })
}

export const reqUpdateCleanupRule = async (token: string, rule: CleanupRule) => {
  return await axios.put(`${baseUrl}/${token}`, {
    rule_data: JSON.stringify({ ...rule }),
  })
}

export const reqDeleteCleanupRule = async (token: string) => {
  return await axios.delete(`${baseUrl}/${token}`)
}
